import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ShButtonComponent } from '@seahorse/components';
import { DialogFooterComponent } from './dialog-footer.component';
import {
  ConfirmOptions,
  DIALOG_DATA,
  DialogContent,
  DialogRef,
} from './dialog.models';

/** The content of `DialogService.confirm`. Internal. */
@Component({
  selector: 'sh-confirm-dialog-content',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [TranslateModule, ShButtonComponent, DialogFooterComponent],
  template: `
    <p class="dialog-message">{{ data.message | translate }}</p>
    <sh-dialog-footer>
      <sh-button
        styleClass="dialog-cancel"
        variant="text"
        [label]="cancelLabel"
        (click)="dialogRef.cancel()"
      ></sh-button>
      <!-- autofocus: PrimeNG focuses this one on show, as the old
           confirm dialog focused its accept button. -->
      <sh-button
        styleClass="dialog-confirm"
        [autofocus]="true"
        [severity]="data.severity === 'danger' ? 'danger' : 'primary'"
        [label]="confirmLabel"
        (click)="dialogRef.ok(true)"
      ></sh-button>
    </sh-dialog-footer>
  `,
})
export class ConfirmDialogContentComponent
  implements DialogContent<ConfirmOptions, boolean>
{
  readonly data = inject<ConfirmOptions>(DIALOG_DATA);
  readonly dialogRef = inject<DialogRef<boolean>>(DialogRef);
  protected readonly confirmLabel =
    this.data.confirmLabel ?? 'shared.terms.confirm';
  protected readonly cancelLabel =
    this.data.cancelLabel ?? 'shared.terms.cancel';
}
